import { Accepts, Types } from "@citychallenge/common";
import { Inlet } from "../../reactive";
import { defineElement } from "../define-element";

export class VRMediaProps {
  @Inlet(Accepts.XR360Renderable) public renderable!: Types["XR360Renderable"];
  @Inlet(Accepts.XRHotspotList) public hotspots?: Types["XRHotspotList"];
  @Inlet(Accepts.MarkdownText) public text?: Types["MarkdownText"];

  @Inlet(Accepts.Subtitles) public subtitles?: Types["Subtitles"];
  @Inlet(Accepts.Number) public startOffset?: number;

  @Inlet(Accepts.Hints) public hints?: Types["Hints"];
  @Inlet(Accepts.Boolean) public debugHotspots?: Types["Boolean"];

  @Inlet(Accepts.Boolean) public enableHotspotEffect?: Types["Boolean"];
}

export const VrMediaDefinition = defineElement("vr-media", VRMediaProps, {
  versionRequired: "0.36.0",
});
